export default class AbortError extends Error {
  constructor(reason: string) {
    super(`The request was aborted: ${reason}`);
  }
}
